import React from "react";
import {withNamespaces} from "react-i18next";
import HilightTable from "../../../../components/HilightTable";
import ConnectionStatus from "../../../../components/ConnectionStatus";
import DeviceInfoColumn from "../../../../components/DeviceInfoColumn";
import DeviceRestartButton from "../../../../components/DeviceRestartButton";
import {connect} from "react-redux";
import {claimTypes} from "../../../../constants/claim.constants";
import MobilePcListItemView from "./_mobile/MobilePcListItemView";
import MobilePcListView from "./_mobile/MobilePcListView";

const WidgetPcList = ({pcList, user, claim, t}) => {

    const claimAccess = user[`c_${claim}`] || null;
    if(claimAccess === claimTypes.NONE) {
        return (
            <React.Fragment/>
        )
    }

    const handleOnClickLabel = (id, event) => {
        event.preventDefault();
    };

    const columns = [
        {
            Header: 'device',
            accessor: 'device',
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <DeviceInfoColumn networkDevice={data} onClickLabel={handleOnClickLabel} />
                )
            }
        },
        {
            Header: 'description',
            accessor: 'description'
        },
        {
            Header: 'status',
            accessor: 'status',
            headerClassName: " text-center wrapok",
            classNameRow: 'text-center',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <ConnectionStatus status={data.isOnline} networkStatus={data.isOnlineNetwork} />
                )
            },
        },
        {
            Header: 'actions',
            accessor: 'actions',
            headerClassName: "text-right",
            width: 5,
            show: claimAccess !== (claimTypes.READ),
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <div style={{ textAlign: "right" }}>
                        <DeviceRestartButton deviceName={data.label} id={data.id} />
                    </div>
                )
            }
        }
    ];

    return (
        <div className="mt-2">
            { pcList?.length ? (
                <div className="card">
                    <div className="card-header">
                        <b><span className="card-title"> {t('pc-list')} </span></b>
                    </div>
                    <div className="card-body">
                        <div className="d-none d-lg-block">
                            <HilightTable
                                columns={columns}
                                data={pcList}
                            />
                        </div>
                        <div className="d-block d-lg-none">
                            <MobilePcListView data={pcList} />
                        </div>
                    </div>
                </div>
            ) : (
                <div className="card">
                    <div className="card-header"><span className="card-title">Pc list</span></div>
                    <div className="card-body">
                        <div className="text-center p-4">
                            <h3>{ t('network-device-no-content')  }</h3>
                        </div>
                    </div>
                </div>
            ) }
        </div>
    )
};
const mapStateToProps = state => {
    const {user} = state.authenticationReducer;
    return {
        user
    }
};
export default withNamespaces()(connect(mapStateToProps)(WidgetPcList));
